import { getResizedImageDimensions } from "./imageAttachments";

interface DrawnImage {
  canvas: HTMLCanvasElement;
  pixels: Uint8ClampedArray;
}

export const drawImageFile = async (file: File, maxSide?: number): Promise<DrawnImage> => {
  const bitmap = await createImageBitmap(file);
  try {
    const { width, height } = getResizedImageDimensions(bitmap, maxSide);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) {
      throw new Error("This browser can't process images.");
    }
    context.drawImage(bitmap, 0, 0, width, height);
    return { canvas, pixels: context.getImageData(0, 0, width, height).data };
  } finally {
    bitmap.close();
  }
};
